var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('div',{staticClass:"dark-2 f14",staticStyle:{"margin-top":"50px"}},[_vm._v("请长按下面的二维码，进入小程序")]),_c('div',{staticClass:"margin-top"},[_c('img',{attrs:{"src":_vm.weixin_mini_app_qrcode}})])])}
var staticRenderFns = []

export { render, staticRenderFns }